module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-plus-619e92d8.svg";